/**
 * ArrowUp – SVG icon.
 */
import IArrow from '@shared/types/props/arrow';
import Screen from '@screen';

/** Upward arrow. */
export default function ArrowUpIcon({ width = 46, height = 27 }: IArrow) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={`${width * Screen.widthRatio}`}
      height={`${height * Screen.widthRatio}`}
      viewBox={'0 0 46 27'}
    >
      <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <g
          transform='translate(-756.000000, -609.000000)'
          fill='#50E3C2'
          stroke='#50E3C2'
          strokeWidth='2'
        >
          <polygon
            id='Arrow-select-item'
            transform='translate(778.836295, 632.250231) rotate(-315.000000) translate(-778.836295, -632.250231) '
            points='763.836295 646.938914 763.836295 617.561549 793.836295 617.561549 793.836295 620.709124 766.994189 620.709124 766.994189 646.938914'
          />
        </g>
      </g>
    </svg>
  );
}
